import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Card,
  Box,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stack,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";

import { httpGet, httpPost } from "../../services/commonService";
import dataConstant from "../../constants/dataConstants";
import urlConstant from "../../constants/urlConstants";
import { selectUserDetail } from "../../redux/slice/userSlice";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import TravelVertexDiscountCardManagement from "../../shared-components/TravelVertexDiscountCardManagement/TravelVertexDiscountCardManagement";

const TravelVertex = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userDetail = useSelector(selectUserDetail);
  const [snack, closeSnack, showSnackbar] = SnackState();
  const authenticationState = useContext(AuthenticationContext);
  const [state, setState] = useState({
    isPopupOpen: false,
    refURL: "",
    isDisplay: false,
    isAlreadyExist: false,
    isValidAventiUser: false,
    aventiPackageDetails: [],
    isValidTrialAventiUser: false,
    trialPeriodEndDate: null,
  });

  useEffect(() => {
    if (userDetail?.UserAccountDetails?.AcctID) {
      httpGet(
        urlConstant.Travertex.GetTravertexUserDetails,
        true,
        true,
        authenticationState.accessToken,
        authenticationState.impersonateEmail
      )
        .then((response) => {
          if (response?.Status === dataConstant.APIResponseStatus.Success) {
            setState((prevState) => ({
              ...prevState,
              isDisplay: true,
              isAlreadyExist: response?.Values?.IsEnrollWithAventiTravel,
              isValidAventiUser: response?.Values?.IsValidAventiUser,
              refURL: userDetail?.UserAccountDetails?.DirectSponsorDetails?.DSReplicationSiteName,
              aventiPackageDetails: response?.Values?.UpgradePackageDetails,
              isValidTrialAventiUser: response?.Values?.IsValidTrialAventiUser,
              trialPeriodEndDate: response?.Values?.TrialPeriodEndDate
            }));
          } else {
            setState((prevState) => ({
              ...prevState,
              isAlreadyExist: false,
            }));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [userDetail?.UserAccountDetails?.AcctID]);

  const createTravertexAccount = () => {
    httpPost(
      urlConstant.Travertex.CreateTravertexAccount,
      {},
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response?.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.error.replace(/[:.]/g, ""), "error");
        }
        if (response?.Status === dataConstant.APIResponseStatus.Success) {
          showSnackbar(response?.description, "success");
          window.location.reload();

          handleOpenNewPage(
            response?.Value?.userCreateResponse?.Response?.RedirectURL
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleOpenNewPage = (redirectURL) => {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(redirectURL);
      newWindow.document.close();
    } else {
      alert("Please allow popups to open the redirect page.");
    }
  };

  const loginTravertexAccount = () => {
    const modelData = {
      FreeTrial: state.isValidTrialAventiUser === true ? true : false,
    };
    httpPost(
      urlConstant.Travertex.LoginTravertexAccount,
      modelData,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response?.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.error.replace(/[:.]/g, ""), "error");
        }
        if (response?.Status === dataConstant.APIResponseStatus.Success) {
          showSnackbar(response?.description, "success");
          handleOpenNewPage(
            response?.Value?.userLoginResponse?.Response?.RedirectURL
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const closePopup = () => {
    setState((prevState) => ({
      ...prevState,
      isPopupOpen: false,
    }));
  };

  return (
    <>
      <Box className="cm-page-title" sx={{ mb: 2 }}>
        <Typography variant="h4" fontWeight={600} color="secondary.text">
          {t("Travertex.Title")}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {state.isDisplay && (
          <Grid size={{ xs: 12, sm: 8, md: 8, lg: 10 }}>
            <Box
              display="flex"
              flexDirection={{ xs: "column", md: "row" }}
              justifyContent="center"
              alignItems="center"
              className="containeraventi"
              sx={{ gap: 4 }}
            >
              <Box className="image-containeraventi">
                <img
                  src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/attractive-woman-in-dress.jpg`}
                  alt="Traveling Woman"
                  style={{ width: "100%", borderRadius: 8 }}
                />
              </Box>
              <Box
                className="text-containeraventi"
                textAlign="center"
                maxWidth={400}
              >
                <Box mb={2}>
                  <img
                    src={`${process.env.REACT_APP_BLOB_URL}/AventiTravelMedia/AventiLogo.png`}
                    alt="AVENTI LOGO"
                    style={{ width: "200px" }}
                  />
                </Box>
                {state.isValidAventiUser === false 
                && !userDetail.PurchasePackageDetails?.IsBYLDerPackagePurchased 
                && userDetail.PurchasePackageDetails?.LatestPackageTypeStatus.toLowerCase() === "inactive" ? (
                  <>
                    <Typography variant="h5" color="var(--black)" mb={2}>
                      {t("Travertex.UpgradeToBYLDerNote")}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={
                        userDetail?.PurchasePackageDetails?.IsBYLDerEnrolled
                          ? () => navigate("/membership")
                          : userDetail?.PurchasePackageDetails?.LatestPackageType.startsWith("Consultant")
                          ? () =>
                              navigate(
                                `/IBOSignup/BYLDerUpgrade/${state.refURL}`,
                                { state: { upgrade: true } }
                              )
                          : userDetail?.PurchasePackageDetails?.LatestPackageType.startsWith("Aventi Travel Business")
                          ? () =>
                              navigate(`/IBOSignup/ATBBYLDerUpgrade/${state.refURL}`, {
                                state: { upgrade: true, isAventiUpgrade: userDetail?.SignupSource === "aventi signup" }
                              })
                          : () => navigate("/membership")
                      }
                    >
                      {t("Common.Upgrade")}
                    </Button>
                  </>
                ) : state.isValidAventiUser === null ? (
                  <>
                    <Typography
                      variant="h5"
                      sx={{ color: "var(--black)" }}
                      mb={2}
                    >
                      {t("Travertex.UpgradeToBYLDerNote")}
                    </Typography>
                    {state.trialPeriodEndDate && (
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)", fontSize: "17px !important" }}
                        mb={2}
                      >
                        {t("Travertex.FreeTrialAccessExpired")}
                      </Typography>
                    )}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        userDetail?.PurchasePackageDetails?.LatestPackageType.startsWith("Consultant") 
                        ? navigate(`/IBOSignup/BYLDerUpgrade/${state.refURL}`, { state: { upgrade: true } }) 
                        : setState(prevState => ({
                          ...prevState,
                          isPopupOpen: true
                        }))
                      }}
                    >
                      {t("Common.Upgrade")}
                    </Button>
                  </>
                ) : (state?.isValidAventiUser === true || state?.isValidAventiUser === false) ? (
                  state.isAlreadyExist ? (state.isValidTrialAventiUser === true ? (
                    <>
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)" }}
                        mb={1}
                      >
                        {t("Travertex.FreeTrialTitle1")}
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)", fontSize: "17px !important" }}
                        mb={2}
                      >
                        {t("Travertex.FreeTrialTitle2")}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginBottom: "10px !important" }}
                        onClick={() => {
                          setState(prevState => ({
                            ...prevState,
                            isPopupOpen: true
                          }))
                        }}
                      >
                        {t("Travertex.UpgradeNow")}
                      </Button>
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)" }}
                        mb={1}
                      >
                        {t("Travertex.FreeTrialTitle3")}
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)", fontSize: "17px !important" }}
                        mb={2}
                      >
                        {t("Travertex.FreeTrialTitle4")}
                        {state.trialPeriodEndDate && (
                          <>
                            <Box component="span" sx={{ fontWeight: "bold" }}>
                              {" until "}{new Date(state.trialPeriodEndDate).toLocaleDateString("en-US", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                              })}
                            </Box>
                          </>
                        )}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={loginTravertexAccount}
                      >
                        {t("Travertex.FreeTrialAccess")}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Typography
                        variant="h5"
                        sx={{ color: "var(--black)" }}
                        mb={2}
                      >
                        {t("Travertex.YouAreAlreadyUserTitle")}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={loginTravertexAccount}
                      >
                        {t("Travertex.BookNow")}
                      </Button>
                    </>
                  )
                  ) : (
                    <>
                      <Typography variant="h5" color="var(--black)" mb={2}>
                        {t("Travertex.Get ready to live")} <br />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "var(--primary-main)",
                          }}
                        >
                          {t("Travertex.unforgettable experiences")}
                        </span>
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={createTravertexAccount}
                      >
                        {t("Travertex.Signup")}
                      </Button>
                    </>
                  )
                ) : (
                  <>
                    <Typography variant="h5" color="var(--black)" mb={2}>
                      {t("Travertex.UpgradeToBYLDerNote")}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={userDetail?.PurchasePackageDetails?.IsBYLDerEnrolled 
                        ? () => navigate('/membership') 
                        : userDetail?.PurchasePackageDetails?.LatestPackageType.startsWith("Consultant") 
                        ? () => navigate(`/IBOSignup/BYLDerUpgrade/${state.refURL}`, { state: { upgrade: true } }) 
                        : userDetail?.PurchasePackageDetails?.LatestPackageType.startsWith("Aventi Travel Business") 
                        ? () => navigate(`/IBOSignup/ATBBYLDerUpgrade/${state.refURL}`, { state: { upgrade: true, isAventiUpgrade: userDetail?.SignupSource === "aventi signup" } })
                        : () => navigate('/membership')
                      }
                    >
                      {t("Common.Upgrade")}
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
      
      {/* Travel Vertex Discount Card Management */}
      <TravelVertexDiscountCardManagement />

      <Dialog
        open={state.isPopupOpen}
        onClose={closePopup}
        sx={{ borderRadius: "20px", background: "transparent" }}
        maxWidth
      >
        <Stack
          sx={(theme) => ({
            background: theme.palette.common.black,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          })}
        >
          <DialogTitle>{t("Common.SignUp")}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={closePopup}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <DialogContent
          sx={{
            background: "var(--primary-darker)!important",
            border: 0,
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
          dividers
        >
          <Stack direction={"row"} flexWrap={"wrap"} gap={2}>
            {state.aventiPackageDetails?.map((item, index) => {
              return (
                <Card
                  key={index}
                  sx={(theme) => ({
                    p: "20px",
                    backgroundImage: theme.palette.background.cardGradient,
                    border: "1px solid var(--white)",
                    borderRadius: "20px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    flex: "1",
                    maxWidth: "100%",
                    minWidth: { xs: "200px", sm: "350px" },
                  })}
                >
                  <Stack alignItems={"center"} gap={"10px"}>
                    <Card
                      sx={(theme) => ({
                        p: "10px",
                        background: theme.palette.secondary.light,
                        borderRadius: "5px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px",
                        padding: "5px 10px",
                        color: theme.palette.common.black,
                        backgroundImage: "none",
                        fontWeight: "600",
                        fontSize: "16px",
                      })}
                    >
                      {userDetail?.SignupSource === "aventi signup" ? item.PackageName : item.HardCodeName}
                    </Card>
                    <img width={80} src="/icons/badge1.svg" alt="user" />
                    <Typography
                      color="secondary.light"
                      variant="h5"
                      fontWeight={600}
                    >
                      ${item.PackagePrice} {t("Common.One-Time")}
                    </Typography>
                    <Typography
                      color="secondary.text"
                      sx={{ fontSize: "12px" }}
                      variant="body1"
                      fontWeight={400}
                      lineHeight={1.7}
                    >
                      (${item.MonthlyPrice} {t("Common.Monthly")})
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ px: 3 }}
                      color="primary"
                      onClick={() => {
                        navigate(`${item.RedirectUrl}${state.refURL}`, {
                          state: { upgrade: true, isAventiUpgrade: userDetail?.SignupSource === "aventi signup" },
                        });
                      }}
                    >
                      {t("Common.BUY PACKAGE")}
                    </Button>
                  </Stack>
                </Card>
              );
            })}
          </Stack>

          <Stack alignItems={"center"} mt={"20px"} textAlign={"center"}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "var(--red)",
                color: "var(--white)",
                px: 3,
                fontWeight: 600,
              }}
              color="primary"
              startIcon={<CloseIcon color="primary" />}
              onClick={closePopup}
            >
              {t("Common.Cancel")}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />
    </>
  );
};
export default TravelVertex;
